import { Component, OnInit } from '@angular/core';
import {DataService} from '../../../../../../services/commande-client/data.service';

@Component({
  selector: 'app-tous-bon-liv',
  templateUrl: './tous-bon-liv.component.html',
  styleUrls: ['./tous-bon-liv.component.scss']
})
export class TousBonLivComponent implements OnInit {

    constructor(private dataService: DataService) {}

    ngOnInit(): void {
        this.dataService.filterOrdersByStatus('Tous');
    }

}
